<template style="background-color:#011332;">
  <b-container>
    <b-card
      v-if="cardType === 0"
      no-body
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <b-img
              fluid
              :src="require(`@/assets/QUANTEEC_logo_panel.png`)"
              class="logonavbar"
            ></b-img>
          </b-col>
        </b-row>

        <b-form @submit.prevent="onSubmit()">
          <b-row class="justify-content-center">
            <b-col class="col-md-6 col-sm-12">
              <b-form-group
                id="exampleInputGroup1"
              >
                <b-form-input
                  id="exampleInput1"
                  type="text"
                  v-model="form.name"
                  required
                  :placeholder="$ml.get('loginUsernamePlaceholder')" 
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
              >
                <b-input-group>
                  <b-form-input
                    id="exampleInput2"
                    :type="passwordType"
                    v-model="form.password"
                    required
                    :placeholder="$ml.get('loginPasswordPlaceholder')" 
                  >
                  </b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      tabindex="-1"
                      v-if="passwordType === 'password'"
                      variant="db-sb1"
                      @click="passwordType = 'text'"
                      ><font-awesome-icon
                        :icon="['fas', 'eye']"
                      ></font-awesome-icon
                    ></b-button>
                    <b-button
                      size="sm"
                      tabindex="-1"
                      v-if="passwordType === 'text'"
                      variant="db-sb1"
                      @click="passwordType = 'password'"
                      ><font-awesome-icon
                        :icon="['fas', 'eye-slash']"
                      ></font-awesome-icon
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <p class="forgotPassword" @click="cardType = 1">
                <small>{{$ml.get('forgotPassword')}}</small>
              </p>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" variant="msstreamblue" size="sm">{{$ml.get('signIn')}}</b-button>
            </b-col>
          </b-row>
        </b-form>

        <p class="text_or">{{$ml.get('orSeparator')}}</p>
        <b-row class="justify-content-center">
          <b-col cols="auto">
            <b-button variant="oauth" @click="urlSigninGithub"><font-awesome-icon :icon="['fab', 'github']" /> {{$ml.get("logingithub")}}</b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 1"
      no-body
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <h4>{{$ml.get('forgotPassword')}}</h4>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onClientPassword()">
          <b-row class="justify-content-center">
            <b-col class="col-md-6 col-sm-12">
              <b-form-group
                id="exampleInputGroup1"
              >
                <b-form-input
                  id="exampleInput1"
                  type="text"
                  v-model="forgotUsername"
                  required
                  :placeholder="$ml.get('enterUsernameForgot')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" size="sm" variant="msstreamblue">
                <font-awesome-icon icon="check" />
                {{$ml.get('validateBtn')}}
              </b-button>
            </b-col>
            <b-col cols="auto">
              <b-button @click="cancelForgot" size="sm" variant="quanteeclg">
                <font-awesome-icon style="color:red" icon="times" />
                {{$ml.get('cancel')}}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 2"
      no-body
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <h4>{{$ml.get('forgotPassword')}}</h4>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onValidateMail()">
          <b-row class="justify-content-center">
            <p v-if="!isUserMail">
              {{$ml.get('newPasswordSentTo')}} <strong>{{ email }}</strong>
            </p>
            <p v-if="isUserMail">
              {{$ml.get('newPasswordSentTo')}} <strong>{{ email }}</strong>
            </p>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" size="sm" variant="msstreamblue">
                <font-awesome-icon icon="check" />
                {{$ml.get('confirm')}}
              </b-button>
            </b-col>
            <b-col cols="auto">
              <b-button @click="cancelForgot" size="sm" variant="quanteeclg">
                <font-awesome-icon style="color:red" icon="times" />
                {{$ml.get('cancel')}}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 3"
      no-body
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <h4>
              {{$ml.get('validEmailMandatory')}}
            </h4>
          </b-col>
        </b-row>
        <b-form-input
          :state="correctMail"
          :placeholder="$ml.get('emailLabel')"
          v-model="newMail"
        >
        </b-form-input>
        <b-form @submit.prevent="putMyEmail">
          <b-row class="justify-content-center">
            <b-col class="col-md-6 col-sm-12"> </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" size="sm" variant="msstreamblue">
                <font-awesome-icon icon="check" />
                {{$ml.get('registerEmailBtn')}}

              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="cardType === 4"
      no-body
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          <b-col class="auto">
            <b-row class="justify-content-center">
              <h4>
                {{$ml.get('modifyAutoGeneratedPassword')}}
              </h4>
            </b-row>
            <b-row class="justify-content-center">
              <small>{{$ml.get('passwordRequirements')}}</small>
            </b-row>
          </b-col>
        </b-row>
        <b-form @submit.prevent="putMyPassword">
        <b-input-group class="justify-content-center">
          <b-form-input
            style="max-width:400px"
            :state="correctPassword"
            :placeholder="$ml.get('newPasswordPlaceholder')"
            v-model="newPassword"
            :type="passwordType"
          >
          </b-form-input>

          <b-input-group-append>
            <b-button
              tabindex="-1"
              v-if="passwordType === 'password'"
              variant="db-sb1"
              size="sm"
              @click="passwordType = 'text'"
              ><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon
            ></b-button>
            <b-button
              tabindex="-1"
              v-if="passwordType === 'text'"
              variant="db-sb1"
              size="sm"
              @click="passwordType = 'password'"
              ><font-awesome-icon
                :icon="['fas', 'eye-slash']"
              ></font-awesome-icon
            ></b-button>
          </b-input-group-append>

          <b-form-invalid-feedback>
            {{$ml.get('passwordRequirements')}}

          </b-form-invalid-feedback>
        </b-input-group>

        <b-input-group class="justify-content-center">
          <b-form-input
            style="max-width:400px"
            :state="indenticalPasswords"
            :placeholder="$ml.get('confirmNewPasswordPlaceholder')"
            v-model="confirmPassword"
            :type="confirmPasswordType"
          >
          </b-form-input>

          <b-input-group-append>
            <b-button
              tabindex="-1"
              v-if="confirmPasswordType === 'password'"
              variant="db-sb1"
              size="sm"
              @click="confirmPasswordType = 'text'"
              ><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon
            ></b-button>
            <b-button
              tabindex="-1"
              v-if="confirmPasswordType === 'text'"
              variant="db-sb1"
              size="sm"
              @click="confirmPasswordType = 'password'"
              ><font-awesome-icon
                :icon="['fas', 'eye-slash']"
              ></font-awesome-icon
            ></b-button>
          </b-input-group-append>

          <b-form-invalid-feedback>
            {{$ml.get('passwordsMustBeIdentical')}}

          </b-form-invalid-feedback>
        </b-input-group>

        
          <b-row class="justify-content-center m-3">
            <b-col class="col-md-6 col-sm-12"> </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="auto">
              <b-button type="submit" size="sm" variant="msstreamblue" >
                <font-awesome-icon icon="check" />
                {{$ml.get('updatePasswordBtn')}}

              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-modal ref="myModalRef" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="exclamation-triangle" />
          {{$ml.get('loginError')}}
       
        </h4>
      </div>
      <div style="text-align:center" v-for="(error, index) in errors" v-bind:key="index">
        <p style="line-height:normal">{{ error }}.
          <br /><br /> {{$ml.get('loginErrorAdvice')}}
        </p>
      </div>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" size="sm" variant="quanteeclg" @click="hideModal('myModalRef')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="userNotFound" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="exclamation-triangle" />
          {{$ml.get('errorUsername')}}

        </h4>
      </div>
      <p style="line-height:normal; text-align:center">{{$ml.get('usernameUnknown')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" size="sm" variant="quanteeclg" @click="hideModal('userNotFound')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="mailError" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="envelope-open" />
          {{$ml.get('errorEmail')}}

        </h4>
      </div>
      <p style="line-height:normal; text-align:center"><strong>{{ errorMsg }}</strong></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" size="sm" variant="quanteeclg" @click="hideModal('mailError')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorMailUsed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="envelope-open" />
          {{$ml.get('errorEmail')}}

        </h4>
      </div>
      <p style="line-height:normal; text-align:center"><strong>{{$ml.get('emailAlreadyUsed')}}</strong></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" size="sm" variant="quanteeclg" @click="hideModal('errorMailUsed')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorMail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'envelope-open']" />
          {{$ml.get('errorEmail')}}

        </h4>
      </div>
      <p style="line-height:normal; text-align:center">{{$ml.get('errorInEmailChange')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" size="sm" variant="quanteeclg" @click="hideModal('errorMail')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="validationMail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'envelope-open']" />
          {{$ml.get('verificationEmailSent')}}

        </h4>
      </div>
      <p style="line-height:normal; text-align:center">{{$ml.get('verificationEmailSentText')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" size="sm" variant="quanteeclg" @click="hideModal('validationMail')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>


    <b-modal ref="mailPassword" hide-footer hide-header>
      <div class="d-block text-center">
        <h4>{{$ml.get('newPasswordSent')}}</h4>
      </div>
      <p>{{$ml.get('newPasswordSentText')}}</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="mswarning"
          size="sm"
          block
          @click="hideModal('mailPassword')"
          >{{$ml.get('close')}}</b-btn
        >
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import UserService from "@/services/user.service";
import SigninService from "@/services/signin.js";
let userService = new UserService();
let signinService = new SigninService();
var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function (e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function (e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function (e) {
    e = e.replace(/\r\n/g, "\n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var c1;
    var c2;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  },
};
export default {
  name: "Login",
  data: function () {
    return {
      form: {
        name: "",
        password: "",
      },
      errorMsg: "",
      forgotUsername: "",
      cardType: 0,
      userClient: "client",
      email: "te**@quanteec.com",
      passwordType: "password",
      errors: [],
      isUserMail: "false",
      newMail: "",
      correctMail: undefined,
      correctPassword: undefined,
      indenticalPasswords: undefined,
      newPassword: "",
      confirmPassword: "",
      confirmPasswordType: "password",
    };
  },
  mounted() {
    if (this.$route.params["username"]) {
      this.form.name = Base64.decode(this.$route.params["username"]);
    }
    if (this.$route.name === "mail") this.cardType = 3;
    if (this.$route.name === "changePassword") this.cardType = 4;
  },
  methods: {
    urlSigninGithub() {
        window.location.href = signinService.urlLoginGithub();
    },
    onSubmit: function () {
      if (this.validateForm()) {
        this.$auth
          .setUsernamePassword(this.form.name, this.form.password)
          .then(() => {
            EventBus.$emit("AuthChanged");
            this.$router.push("/").catch(() => null);
          })
          .catch(() => {
            this.errors.push(this.$ml.get('wrongUsernameOrPassword'));
            this.showModal("myModalRef");
          });
      }
    },
    onReset: function () {
      this.form = {
        name: "",
        password: "",
      };
    },
    onClientPassword: function () {
      userService
        .getUserForgot(this.forgotUsername)
        .then((client) => {
          this.email = client.email;
          console.log(client.isUserMail);
          this.isUserMail = client.isUserMail;
          this.cardType = 2;
        })
        .catch((err) => {
          this.showModal("userNotFound");
        });
    },
    cancelForgot: function () {
      this.cardType = 0;
      this.email = "";
      this.forgotUsername = "";
      this.onReset();
    },
    onValidateMail: function() {
      userService.postUserForgot(this.forgotUsername).then(() => {
        this.showModal("mailPassword")
        this.cardType = 0;
      }).catch(err => {
        console.log("Error : ", err)
        if (err.response && err.response.data) {
          this.errorMsg = err.response.data
        } else {
          this.errorMsg = this.$ml.get('unknownErrorContact')
        }
        this.showModal('mailError')
      })
    },
    validateForm: function () {
      var isValidated = true;
      this.errors = [];
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.form.name)) {
        isValidated = true;
      }
      return isValidated;
    },
    showModal(myModalRef) {
      this.$refs[myModalRef].show();
    },
    hideModal(myModalRef) {
      this.$refs[myModalRef].hide();
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    putMyEmail() {

      if (this.validateEmail(this.newMail)) {
        this.correctMail = true;
        userService
          .putUser(
            this.$auth.getMyUser().username,
            {
              newEmail: this.newMail,
              emailVerified: false,
              oldPassword: atob(this.$auth.token()).split(":")[1],
              keyMail: [...Array(64)]
                .map((i) => (~~(Math.random() * 36)).toString(36))
                .join(""),
                timestamp:new Date(),
            },
            this.$auth.token()
          )
          .then((user) => {
            this.showModal("validationMail")
            this.$auth
              .validateWithServer()
              .then(() => {
                EventBus.$emit("AuthChanged");
              })
              .catch((err) => {
                EventBus.$emit("AuthChanged");
                if (window.location.href.indexOf("/#/auth") === -1) {
                  this.$router.push("/auth");
                }
              });
          })
          .catch((err) => {
            this.correctMail = false;
            if (err.response.status === 409) this.showModal("errorMailUsed");
            else {
              this.showModal("errorMail");
            }
          });
      } else {
        this.correctMail = false;
      }
    },
    putMyPassword() {
      if (this.newPassword != this.confirmPassword) {
        this.indenticalPasswords = false;
        return;
      } else {
        this.indenticalPasswords = "";
      }

      let count = 0;
      if (this.newPassword.length >= 7) {
        if (this.newPassword.match(/.*[0-9].*/)) count++;

        if (this.newPassword.match(/.*[a-z].*/)) count++;

        if (this.newPassword.match(/.*[A-Z].*/)) count++;

        if (this.newPassword.match(/.*[!@#\$%\^\&*\)\(+=._-].*/)) count++;
      }

      if (count === 4) {
        this.correctPassword = true;
        this.indenticalPasswords = true;
        userService
          .putUser(
            this.$auth.getMyUser().username,
            { password: this.newPassword, oldPassword:atob(this.$auth.token()).split(":")[1] },
            this.$auth.token()
          )
          .then((user) => {
            this.$auth.setUsernamePassword(
              this.$auth.getMyUser().username,
              this.newPassword
            );

            this.$auth
              .validateWithServer()
              .then(() => {
                EventBus.$emit("AuthChanged");
                this.$router.push("/");
              })
              .catch((err) => {
                EventBus.$emit("AuthChanged");
                if (window.location.href.indexOf("/#/auth") === -1) {
                  this.$router.push("/auth");
                }
              });
          })
          .catch((err) => {
            this.showModal("errorPassword");
            console.log(err);
          });
      } else {
        this.correctPassword = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
body {
  background: black;
}

.forgotPassword {
  color: white;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.logonavbar {
  width: 450px;
  margin: 3rem;
}

.text_or {
  display: flex;
  font-size: small;
  align-items:center;
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
}

.text_or:before, .text_or:after {
  margin-right: 2vw;
  margin-left: 2vw;
  content: "";
  height: 1px;
  width: 100%;
  display: inline-flex;
  vertical-align: top;
  opacity: .4;
  background-color: white;
  box-sizing: border-box;
}
</style>
